import React from 'react';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../Store';
import SEO from '../components/seo';
import Layout from '../components/layouts/Layout';

import '../components/help/style.scss';

export class Help extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            disabled: false,
            name: this.props.user.player.name,
            email: this.props.user.player.email,
            comments: '',
            csrf_token: '',
            form_submitted: '1',
        };

        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handleCommentChange = this.handleCommentChange.bind(this);
        this.submitFeedback = this.submitFeedback.bind(this);
    }

    componentDidMount() {
        this.getPlayerInfo();
        this.props.actions.feedbackActions.reset();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.user.player.name !== this.props.user.player.name) {
            this.getPlayerInfo();
        }
    }

    async getPlayerInfo() {
        this.setState({
            disabled: false,
            name: this.props.user.player.name,
            email: this.props.user.player.email,
            comments: '',
            csrf_token: '',
            form_submitted: '1',
        });
    }

    handleNameChange(event) {
        this.setState({
            name: event.target.value,
        });
    }

    handleEmailChange(event) {
        this.setState({
            email: event.target.value,
        });
    }

    handleCommentChange(event) {
        this.setState({
            comments: event.target.value,
        });
    }

    async submitFeedback(event) {
        this.setState({
            disabled: true,
        });

        this.props.actions.feedbackActions.reset();

        event.preventDefault();

        if (!this.state.disabled) {
            await this.props.actions.feedbackActions.postFeedback(this.state);
            document.getElementById('nav-target').scrollIntoView(true);
        }

        if (!this.props.isError) {
            this.setState({
                disabled: false,
                comments: '',
            });
        }
    }

    renderSuccess(success) {
        if (success) {
            return (
                <div className="alert alert-success text-center" role="alert">
                    <p>
                        <strong>Thank you. Your email has been sent.</strong>
                    </p>
                    <p>
                        A player service representative will review your
                        feedback and respond as necessary to the email address
                        you provided.
                    </p>
                </div>
            );
        }
    }

    renderError(isError, error) {
        var errors = error.split(/<br\/>/g).filter(item => {
            return item.length > 0;
        });
        if (isError) {
            return (
                <div className="alert alert-danger text-center" role="alert">
                    {errors.map(err => {
                        var htmlFilteredError = err.replace(/<[^>]*>/g, '');

                        return <div key={err}>{htmlFilteredError}</div>;
                    })}
                </div>
            );
        }
    }

    render() {
        const formUrl = '/monopoly/feedback.php';

        return (
            <Layout
                user={this.props.user}
                notification={this.props.notification}
                actions={this.props.actions}
            >
                <SEO title="Feedback" />
                <div className="promo-content help">
                    <div className="upper-content">
                        <h1 className="title-section text-center">FEEDBACK</h1>
                    </div>
                    <div className="lower-content">
                        <div className="inner-area">
                            <div className="dark-semi-opaque-theme">
                                <p>
                                    Please use this form to submit your comments
                                    pertaining to the Illinois Lottery{' '}
                                    <strong>ROAD TO $1 MILLION</strong> 2nd
                                    Chance Drawings. Just fill out the fields
                                    below and click on the{' '}
                                    <strong>Submit</strong> button.
                                </p>
                            </div>
                            <div className="lower-rounded-container">
                                {this.renderError(
                                    this.props.feedback.isError,
                                    this.props.feedback.error
                                )}
                                {this.renderSuccess(
                                    this.props.feedback.success
                                )}

                                <form
                                    name="feedback_form"
                                    id="feedback_form"
                                    action={formUrl}
                                    disabled={this.state.disabled}
                                    method="post"
                                    encType="application/x-www-form-urlencoded"
                                    onSubmit={this.submitFeedback}
                                >
                                    <div className="form-group">
                                        <label htmlFor="name">Name:</label>
                                        <input
                                            type="text"
                                            id="name"
                                            name="name"
                                            value={this.state.name}
                                            size="32"
                                            maxLength="120"
                                            onChange={this.handleNameChange}
                                            placeholder="Enter Name"
                                            className="form-control"
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="email">Email:</label>
                                        <input
                                            type="text"
                                            id="email"
                                            name="email"
                                            value={this.state.email}
                                            onChange={this.handleEmailChange}
                                            size="32"
                                            maxLength="60"
                                            placeholder="Enter E-mail"
                                            className="form-control"
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="comments">
                                            Comments:
                                        </label>
                                        <textarea
                                            id="comments"
                                            name="comments"
                                            value={this.state.comments}
                                            onChange={this.handleCommentChange}
                                            rows="10"
                                            cols="50"
                                            wrap="soft"
                                            className="form-control"
                                        />
                                    </div>
                                    <div className="submit-div">
                                        <button
                                            id="entry-submit"
                                            name="submit"
                                            type="submit"
                                        >
                                            Submit
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Help);
